<template>
	<div>
		<vxe-modal v-model="modal_model" :title="modal_title" :width="modal_width" :height="modal_height"
			@show="modal_onshow" show-footer @hide="modal_onhide" destroy-on-close>
			<template #default>
				<el-form ref="form" :model="form" label-width="0px">
					<el-divider content-position="center">统计时间</el-divider>
					<el-form-item label="" required>
						<datePicker :shortcuts="[]" v-model="form.date"  />
					</el-form-item>
<!-- 					<el-divider content-position="center">统计类型</el-divider>
					<el-radio-group v-model="form.type" size="small">
						<el-radio label="仓库" border>仓库</el-radio>
						<el-radio label="快递" border>快递</el-radio>
					</el-radio-group> -->
				</el-form>
			</template>
			<template #footer>
				<vxe-button status="" content="返回" @click="modal_cancel"></vxe-button>
				<vxe-button status="primary" content="确认" @click="submit"></vxe-button>
			</template>
		</vxe-modal>
	</div>
</template>
<style scoped>

</style>
<script>
	import modalMixins from '@_system/components/base/mixins/modal/modal.js'
	import datePicker from '@_system/components/formcomponents/common/datePicker/index.vue'
	//import inputNumber from '@_system/components/formcomponents/common/inputNumber/index.vue'
	export default {
		mixins: [modalMixins],
		props: {
			data: {
				default: () => {
					return []
				}
			},
			type: {
				default: () => {
					return 'month'
				}
			},
			unit: {
				default: () => {
					return 'month'
				}
			},
		},
		data() {
			return {
				modal_title: '',
				modal_width: 500,
				modal_height: 500,
				form: {
					date: null,
					type:null
				}
			}
		},
		watch: {

		},
		computed: {
			device() {
				return window.systemMethods.device()
			}
		},
		created() {

		},
		mounted() {

		},
		methods: {
			modal_init() {
				this.form = {
					date: [this.$Moment().subtract(7, 'day').startOf('day').valueOf(),this.$Moment().subtract(1, 'day').startOf('day').valueOf()],
					type:null
				}
				this.modal_title = this.data.name
				this.modal_model = true
			},
			// modal_show(){

			// 	this.$api.downloadstatic.getexcle({
			// 		code: this.data.code,
			// 	}).then(() => {
			// 		this.$message.success('创建下载任务成功，文件将推送至钉钉')
			// 		this.modal_cancel()
			// 	})
			// },
			submit() {				
				if (this.form.date.length!=2) {
					this.$message.error('请选择统计时间')
					return
				}
				// if (!this.form.type) {
				// 	this.$message.error('请选择统计类型')
				// 	return
				// }				
				this.$api.downloadstatic.getexcletask({
					code: this.data.code,
					begin: this.form.date[0]/1000,
					end: this.form.date[1]/1000
				}).then(() => {
					this.$message.success('创建下载任务成功，文件将推送至钉钉')
					//this.modal_cancel()
				})				
			},
			reset() {

			}
		},
		components: {
			datePicker,
			//inputNumber
		}
	}
</script>